import { render, staticRenderFns } from "./InvoicesRec.vue?vue&type=template&id=7458ef30&scoped=true"
import script from "./InvoicesRec.vue?vue&type=script&lang=js"
export * from "./InvoicesRec.vue?vue&type=script&lang=js"
import style0 from "./InvoicesRec.vue?vue&type=style&index=0&id=7458ef30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7458ef30",
  null
  
)

export default component.exports